import { render, staticRenderFns } from "./radar.vue?vue&type=template&id=1899caf5&scoped=true"
import script from "./radar.vue?vue&type=script&lang=js"
export * from "./radar.vue?vue&type=script&lang=js"
import style0 from "./radar.vue?vue&type=style&index=0&id=1899caf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899caf5",
  null
  
)

export default component.exports